export default __webpack_public_path__ + "static/media/location_preview_deep_dive.4a3d8d37.svg";